<template>
  <div>
    <button @click="prepareRecording" :disabled="disableButton.start">
      Start Recording
    </button>
    <button @click="stopRecording" :disabled="disableButton.stop">
      Stop Recording
    </button>
    <br />
    <div class="section">
      <div>状态：</div>
      <div>{{ recordingStatus }}</div>
    </div>
    <div class="section">
      <div>最终录音结果：</div>
      <div>{{ resultText }}</div>
    </div>
    <div class="section">
      <div>录音过程：</div>
      <div class="recording">
        <p v-for="(recordText, index) in recordings" :key="index">
          {{ recordText }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { AccessToken } from "../../utils/aliyuntoken";

export default {
  data() {
    return {
      accessToken: {
        token: null,
        expireTime: null,
      },
      audioContext: null,
      audioProcessor: null,
      disableButton: {
        start: false,
        stop: true,
      },

      pcmBuffer: new Int16Array(),
      mediaRecorder: null,
      recordingStatus: null,
      recordings: [],
      websocket: null,
      resultText: "",
    };
  },
  created() {
    const accessKeyId = "LTAI5t9B31xMeV5kcsXksKq2";
    const accessKeySecret = "qhiPxlfhyLzMzt3vAzTz3ywSaXKPlK";
    AccessToken.createToken(accessKeyId, accessKeySecret).then(
      ({ token, expireTime }) => {
        console.log(
          "Barry Token at ali nls:",
          token,
          "Expire Time:",
          expireTime
        );
        this.accessToken = {
          token,
          expireTime,
        };
      }
    );
  },
  methods: {
    generateUniqueID() {
      return Array(32)
        .fill(0)
        .map(() => Math.floor(Math.random() * 16).toString(16))
        .join("");
    },

    onTextChanged(text) {
      const recordings = this.recordings || [];
      const count = recordings.length;
      if (count > 0) {
        recordings[count - 1] = text;
      } else {
        recordings[0] = text;
      }

      this.recordings = recordings;
    },

    onTextFinished(text) {
      const recordings = this.recordings || [];
      const count = recordings.length;
      if (count > 0) {
        recordings[count - 1] = text;
      } else {
        recordings[0] = text;
      }

      this.recordings = recordings;

      this.resultText += text;
      console.log("resultText:", this.resultText);
    },

    // 实现16000音频采样率
    async resampleAudioBuffer(audioBuffer, targetSampleRate) {
      const numberOfChannels = audioBuffer.numberOfChannels;
      const offlineContext = new OfflineAudioContext(
        numberOfChannels,
        audioBuffer.duration * targetSampleRate,
        targetSampleRate
      );

      const bufferSource = offlineContext.createBufferSource();
      bufferSource.buffer = audioBuffer;
      bufferSource.connect(offlineContext.destination);
      bufferSource.start();

      const resampledAudioBuffer = await offlineContext.startRendering();
      return resampledAudioBuffer;
    },

    async startCaptureAudio() {
      this.recordingStatus = "可以开始录音了！";
      this.audioContext = new AudioContext();
      const sampleRate = this.audioContext.sampleRate;
      console.log("Original sampleRate: ", sampleRate);

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const source = this.audioContext.createMediaStreamSource(stream);

      this.audioProcessor = this.audioContext.createScriptProcessor(1024, 1, 1);
      this.audioProcessor.onaudioprocess = async (event) => {
        const inputBuffer = event.inputBuffer;

        // Resample the buffer if needed
        let resampledBuffer = inputBuffer;
        if (sampleRate !== 16000) {
          resampledBuffer = await this.resampleAudioBuffer(inputBuffer, 16000);
        }

        const pcmData = this.convertToPCM(resampledBuffer);
        this.pcmBuffer = this.concatenateTypedArrays(
          this.pcmBuffer,
          new Int16Array(pcmData)
        );

        while (this.pcmBuffer.length * 2 >= 3200) {
          const chunk = this.pcmBuffer.slice(0, 3200 / 2);
          this.websocket.send(chunk.buffer);
          this.pcmBuffer = this.pcmBuffer.slice(3200 / 2);
        }
      };

      source.connect(this.audioProcessor);
      this.audioProcessor.connect(this.audioContext.destination);
    },

    async prepareRecording() {
      this.disableButton.start = true;
      this.disableButton.stop = false;
      this.recordingStatus = "正在连接阿里云...";
      const APPKEY = "hL4rwJ2DVDxyRttG";
      const TOKEN = this.accessToken.token;
      const URL = `wss://nls-gateway.cn-shanghai.aliyuncs.com/ws/v1?token=${TOKEN}`;

      this.websocket = new WebSocket(URL);
      this.websocket.onopen = () => {
        const instruction = {
          header: {
            appkey: APPKEY,
            message_id: this.generateUniqueID(),
            task_id: this.generateUniqueID(),
            namespace: "SpeechTranscriber",
            name: "StartTranscription",
          },
          payload: {
            format: "PCM",
            sample_rate: 16000,
            enable_intermediate_result: true,
            enable_punctuation_prediction: true,
            enable_inverse_text_normalization: true,
            max_sentence_silence: 500,
          },
        };
        this.websocket.send(JSON.stringify(instruction));
      };

      this.websocket.onmessage = (e) => {
        const ret = JSON.parse(e.data);
        if (ret.header.name === "TranscriptionResultChanged") {
          this.onTextChanged(ret.payload.result);
        } else if (ret.header.name === "SentenceBegin") {
          const recordings = this.recordings || [];
          recordings.push("");
          this.recordings = recordings;
        } else if (ret.header.name === "TranscriptionStarted") {
          this.startCaptureAudio();
        } else if (ret.header.name === "SentenceEnd") {
          this.onTextFinished(ret.payload.result);
        } else if (ret.header.name === "TranscriptionCompleted") {
          console.log("服务端已停止了语音转写", ret);
        } else {
          console.log("response: ", e);
        }
      };
    },

    convertToPCM(audioBuffer) {
      let float32Array = audioBuffer.getChannelData(0);
      let pcmData = new Int16Array(float32Array.length);

      for (let i = 0; i < float32Array.length; i++) {
        let s = Math.max(-1, Math.min(1, float32Array[i]));
        pcmData[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
      }

      return pcmData.buffer;
    },

    concatenateTypedArrays(a, b) {
      const result = new a.constructor(a.length + b.length);
      result.set(a);
      result.set(b, a.length);
      return result;
    },

    stopRecording() {
      this.recordingStatus = "已停止录音";
      this.disableButton.start = false;
      this.disableButton.stop = true;
      if (this.audioProcessor) {
        this.audioProcessor.disconnect();
        this.audioProcessor = null;
      }
      if (this.websocket) {
        this.websocket.close();
        this.websocket = null;
      }
    },
  },
};
</script>
<style scoped>
.section {
  margin-top: 32px;
  display: flex;
  width: 100%;
  justify-content: center;
}
.recording {
  overflow-y: scroll;
  border: 2px solid #eee;
  width: 800px;
  height: 300px;
  color: #666;
  text-align: center;
}
</style>